import React from 'react';
import blogs from '../../api/blogs'
import { Link } from "react-router-dom";

const BlogSectionS2 = () => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <section className="blog-section-s2 section-padding">
            <div className="container">
                <div className="title">
                    <h2 className="scroll-text-animation" data-animation="fade_from_bottom">Mrmetallo News</h2>
                    <div className="title-bottom">
                        <h3 className="scroll-text-animation" data-animation="fade_from_bottom" style={{fontSize: window.innerWidth >= 768 ? "48px" : "30px"}}>NEWS</h3>
                        <Link onClick={ClickHandler} to="/"> <span className="rolling-text" style={{marginRight:"10px"}}>엠알메탈로 소식 상세보기</span>
                            <i className="ti-arrow-top-right"></i>
                        </Link>
                    </div>
                </div>
                <div className="row">
                    {blogs.slice(0, 3).map((blog, bitem) => (
                        <div className="col-lg-4 col-md-6 col-12 fade_bottom" key={bitem}>
                            <div className="blog-card">
                                <div className="image">
                                    <img src={blog.screens} alt="" />
                                    <img src={blog.screens} alt="" />
                                </div>
                                <div className="content">
                                    <span>{blog.create_at}</span>
                                    <h3 style={{border:"none"}} ><a href='/' onClick={(e) => e.preventDefault()} style={{cursor: 'default', pointerEvents: 'none'}}>{blog.title}</a></h3>
                                    <a href='/' onClick={(e) => e.preventDefault()} style={{cursor: 'default', pointerEvents: 'none'}}> <span style={{height: 'auto', overflow: 'visible', lineHeight: '1.6', display: 'block', textDecoration: 'none'}}>{blog.description}</span></a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default BlogSectionS2;

